import { ChevronDown } from '@wix/wix-ui-icons-common'
import React, { FC, memo } from 'react'

import { WixStudioAvatar } from '../WixStudioAvatar'
import Icons from './Icons.svg'
import Logo from './Logo.svg'
import Menu from './Menu.svg'
import s from './WixStudioVisual.scss'

export const WixStudioVisual: FC<{ avatar: { letter?: string; loading?: boolean }; className?: string }> = memo(
  ({ children, avatar, className }) => (
    <div className={`${s.root} ${className || ''}`}>
      <div className={s.inner}>
        <div className={s.header}>
          <Logo className={s.logo} />
          <Icons className={s.icons} />
          <WixStudioAvatar label={avatar.letter} loading={avatar.loading} d="23px" />
          <ChevronDown color="#fff" />
        </div>
        <div className={s.content}>
          <div className={s.sidebar}>
            <Menu />
          </div>
          {children}
        </div>
      </div>
    </div>
  ),
)
